<template>
  <div>
    <header
      class="category-page-header"
      :style="{ backgroundImage: `url(${headerImage})` }"
    ></header>
    <v-container class="mx-auto">
      <v-card :loading="isLoading" class="header--form">
        <v-row no-gutters>
          <div class="col-12 col-sm-12 col-md-5">
            <div class="title--area">
              <p>{{ formData.description.upperText }}</p>
              <div>{{ formData.description.title }}</div>
              <h1>{{ formData.description.bottomText }}</h1>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-7 form-right-border">
            <div class="form-area">
              <v-form
                :id="formID"
                @submit="sendOffer"
                lazy-validation
                ref="form"
                v-model="valid"
              >
                <p class="text-center">(*) Doldurulması zorunlu alanlar.</p>
                <v-row no-gutters class="justify-center gap-1">
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    v-if="
                      formData.identity &&
                        $route.name !== 'ForeignHealthInsurance'
                    "
                  >
                    <v-text-field
                      label="(*)TC Kimlik No"
                      v-model="item.customer.identityNumber"
                      v-mask="'###########'"
                      :rules="tcknoRule"
                      required
                      solo
                      hide-details="auto"
                      type="number"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="5"
                    md="5"
                    v-if="
                      formData.identity &&
                        $route.name === 'ForeignHealthInsurance'
                    "
                  >
                    <v-text-field
                    v-if="formData.identity && $route.name !== 'ForeignHealthInsurance'"
                      label="TC Kimlik No"
                      v-model="item.customer.identityNumber"
                      v-mask="'###########'"
                      :rules="tcknoRule"
                      required
                      solo
                      hide-details="auto"
                      type="number"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="5"
                    md="5"
                    v-if="
                      formData.identity &&
                        $route.name === 'ForeignHealthInsurance'
                    "
                  >
                    <v-text-field
                    v-if="formData.identity && $route.name !== 'ForeignHealthInsurance'"
                      label="Pasaport Numarası"
                      v-model="item.customer.passportNumber"
                      :rules="passportRule"
                      v-mask="'A########'"
                      solo
                      hide-details="auto"
                      type="number"
                    >
                    </v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" v-if="formData.plate">
                    <v-row no-gutters>
                      <v-radio-group v-model="plateIsExist" row>
                        <v-col cols="5">
                          <v-radio label="Plakam Var" :value="true"></v-radio>
                        </v-col>
                        <v-col cols="7">
                          <v-radio
                            label="Sıfır Araç, Plakam Yok"
                            :value="false"
                          ></v-radio
                        ></v-col>
                      </v-radio-group>
                    </v-row>
                  </v-col> -->

                  <v-col cols="12" sm="5" :md="$route.name === 'ForeignHealthInsurance' ? '12' : '5'" v-if="formData.fullname">
                    <v-text-field
                      v-model="item.customer.name"
                      required
                      label="(*) Adınız"
                      :rules="requiredRules"
                      solo
                      hide-details="auto"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" :md="$route.name === 'ForeignHealthInsurance' ? '12' : '5'" v-if="formData.fullname">
                    <v-text-field
                      v-model="item.customer.surname"
                      :rules="requiredRules"
                      required
                      label="(*) Soyadınız"
                      solo
                      hide-details="auto"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="5" md="5" v-if="formData.email">
                    <v-text-field
                    v-if="formData.identity && $route.name !== 'ForeignHealthInsurance'"
                      v-model="item.customer.mail"
                      type="email"
                      :rules="emailRules"
                      label="E-posta Adresiniz"
                      solo
                      hide-details="auto"
                      :class="$route.name === 'ForeignHealthInsurance' ? 'ym-record-keys' : 'ym-record-keys'"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" :md="$route.name === 'ForeignHealthInsurance' ? '12' : '5'" v-if="formData.phone">
                    <v-text-field
                      v-model="item.customer.mobileNumber"
                      label="(*) Telefon Numaranız"
                      type="tel"
                      :rules="phoneRules"
                      solo
                      v-mask="'0##########'"
                      hide-details="auto"
                      :class="'ym-record-keys'"
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12" sm="5" v-if="formData.plate">
                    <v-text-field
                      v-model="item.customer.vehicle.licensePlate"
                      @keyup="uppercasePlate()"
                      solo
                      placeholder="34 ALKS 34"
                      hide-details="auto"
                      label="Plakanız"
                      required
                      prefix="TR"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" md="5" v-if="formData.document">
                    <v-text-field
                      v-model="item.customer.vehicle.licenseSerialNo"
                      label="Belge Seri No"
                      v-mask="'AA######'"
                      solo
                      required
                      hide-details="auto"
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12" sm="10" md="10">
                    <v-autocomplete
                      v-if="formData.job"
                      solo
                      hide-details="auto"
                      label="Mesleğiniz"
                      v-model="item.customer.job"
                      :items="jobs"
                      return-object
                      item-value="code"
                      item-text="name"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-checkbox
                  v-model="acceptTermCheckBox"
                  class="insurance-form__checkbox--rule"
                  required
                >
                  <template v-slot:label>
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="/kullanici-sozlesmesi"
                            @click.stop
                            v-on="on"
                          >
                            Kullanıcı sözleşmesini
                          </a>
                        </template>
                        www.alokasko.com/kullanici-sozlesmesi
                      </v-tooltip>
                      ve
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="/cerez-politikasi"
                            @click.stop
                            v-on="on"
                          >
                            çerez politikasını
                          </a>
                        </template>
                        www.alokasko.com/cerez-politikasi
                      </v-tooltip>
                      okudum, onaylıyorum. Alokasko işlemlerimi takip edebilir.
                    </div>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-model="personalDataAccept"
                  class="insurance-form__checkbox--rule"
                  required
                >
                  <template v-slot:label>
                    <div>
                      Kişisel verilerimin
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="/kisisel-verilerin-korunmasi"
                            @click.stop
                            v-on="on"
                          >
                            KVKK aydınlatma ve açık rıza metinlerinde
                          </a>
                        </template>
                        www.alokasko.com/kisisel-verilerin-korunmasi
                      </v-tooltip>
                      belirtildiği gibi işlenmesini onaylıyorum.
                    </div>
                  </template>
                </v-checkbox>
                <v-btn
                  large
                  block
                  class="white--text mb-5"
                  :style="{ background: !formValidation ? 'grey' : '#224099' }"
                  :disabled="isLoading || !formValidation"
                  type="submit"
                >
                  {{ formData.button }}
                </v-btn>
              </v-form>
            </div>
          </div>
        </v-row>
      </v-card>
    </v-container>
    <v-dialog v-model="errorDialog" max-width="max-content">
      <v-card color="error pa-5">
        <v-card-title class="text-h6 white--text">
          Lütfen Zorunlu Alanları Doldurunuz ve Bilgilerinizi Doğru
          Girdiğinizden Emin Olunuz.
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successDialog" max-width="580">
      <v-card color="success pa-5">
        <v-card-title class="text-h6 white--text">
          Talebiniz Alınmıştır. Uzmanlarımız en kısa sürede size dönüş
          yapacaktır.
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QuotationType from "@/data/QuotationType"
import * as axios from "axios"
import RestApiConstants from "@/data/RestApiConstants"
export default {
  props: {
    approveRoute: {
      type: String,
      require: false
    },
    formData: {
      type: Object,
      require: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    insuranceType: {
      type: String,
      default: ""
    },
    formID: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      API_BASE_URL: null,
      valid: true,
      isLoading: false,
      jobs: [],
      errorDialog: false,
      successDialog: false,
      requiredRules: [value => !!value || "Doldurmak zorunludur."],
      // phoneNumberRules: [value => !!value || "Doldurmak zorunludur.", value => (value.length < 11 || "").length < 11 || "11 Haneli Olmalıdır"],
      tcknoRule: [
        value => {
          if (this.$route.name !== "ForeignHealthInsurance") {
            return !!value || "Doldurmak zorunludur."
          }
        },
        value => (value || "").length <= 11 || "11 karakterden fazla olamaz.",
        value => {
          const pattern = /^([0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9])$/
          return pattern.test(value) || "Tc Kimlik doğru değil"
        }
      ],
      emailRules: [
        v => !!v || "E-mail gereklidir",
        v => /.+@.+\..+/.test(v) || "Geçerli bir e-mail adresi giriniz."
      ],
      passportRule: [
        value => {
          const pattern = /[a-zA-Z]{2}[0-9]{7}/
          return pattern.test(value) || ""
        }
      ],
      plakaRule: [
        value =>
          (value || "").length <= 11 || "Plaka 9 karakterden fazla olamaz.",
        value => {
          const pattern = /^(0[1-9]|[1-7][0-9]|8[01])(([A-Z])|([A-Z]{2})|([A-Z]{3}))([0-9]|[0-9][0-9]|[0-9][0-9][0-9]|[0-9][0-9][0-9][0-9])$/
          return pattern.test(value) || "Plaka doğru değil"
        }
      ],
      phoneRules: [
        value => !!value || "Doldurmak zorunludur.",
        value => {
          const pattern = /(05|5)[0-9][0-9][0-9]([0-9]){6}/
          return pattern.test(value) || "11 Haneli Olmalıdır"
        }
      ],
      plateIsExist: true,
      route: null,
      yearVisibility: false,
      modelVisibility: false,
      newCar: false,
      acceptTermCheckBox: false,
      personalDataAccept: false,
      brand: "",
      year: "",
      item: {
        customer: {
          insuranceType: null,
          name: null,
          surname: null,
          identityNumber: null,
          passportNumber: null,
          mobileNumber: null,
          mail: null,
          job: null,
          vehicle: {
            licensePlate: null,
            licenseSerialNo: null,
            licenseOrderNo: null,
            vehicleModel: null
          }
        },
        insuranceType: null
      }
    }
  },
  async mounted() {
    await axios
      .get("config.json")
      .then(resp => (this.API_BASE_URL = resp.data.BASE_URL))
    if (this.formData.job) {
      this.fetchJobs()
    }
    const routeName = this.$route.name
    this.item.insuranceType = QuotationType[routeName]
    this.item.customer.insuranceType = QuotationType[routeName]

    // Yandex Metrica takibi için talep edildi.
    if (this.$route.name !== 'ForeignHealthInsurance') {
      document.querySelector("div.ym-record-keys input[type='email']").classList.add("ym-record-keys");
    }
    document.querySelector("div.ym-record-keys input[type='tel']").classList.add("ym-record-keys");
  },
  methods: {
    postOfferService() {
      console.log(this.item)
      this.isLoading = true
      axios
        .post(this.API_BASE_URL + RestApiConstants.OFFER_POST_URL, this.item)
        .then(response => {
          this.$router.push({
            name: this.$route.name,
            query: { success: this.formID }
          })
          this.successDialog = true
          this.resetFormData()
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => (this.isLoading = false))
    },
    fetchJobs() {
      axios
        .get(this.API_BASE_URL + RestApiConstants.JOB_LIST_URL)
        .then(resp => (this.jobs = resp.data))
        .catch(e => console.log(e))
    },
    sendOffer(e) {
      e.preventDefault()

      if (this.$route.name === "ForeignHealthInsurance") {
        const validate = this.foreignFormValidation()
        if (validate) {
          this.postOfferService()
        } else this.errorDialog = true
      } else {
        const validate = this.generalFormValidation()
        if (validate && this.acceptTermCheckBox) {
          this.postOfferService()
        } else {
          this.errorDialog = true
        }
      }
    },
    uppercasePlate() {
      const isExist = !!this.item.customer.vehicle.licensePlate
      if (isExist) {
        this.item.customer.vehicle.licensePlate = this.item.customer.vehicle.licensePlate.toUpperCase()
      }
    },
    resetFormData() {
      this.acceptTermCheckBox = false
      this.personalDataAccept = false
      this.item = {
        customer: {
          insuranceType: this.item.customer.insuranceType || null,
          name: null,
          surname: null,
          identityNumber: null,
          mobileNumber: null,
          passportNumber: null,
          mail: null,
          job: null,
          vehicle: {
            licensePlate: null,
            licenseSerialNo: null,
            licenseOrderNo: null,
            vehicleModel: null
          }
        },
        insuranceType: this.item.customer.insuranceType || null
      }
    },
    foreignFormValidation() {
      const mobilePattern = /(05|5)[0-9][0-9][0-9]([0-9]){6}/
      const name = this.item.customer.name
      const surname = this.item.customer.surname
      const mobileNumber = this.item.customer.mobileNumber
      const mobileIsTrue = mobilePattern.test(mobileNumber)
      if (
        !name ||
        !surname ||
        !mobileNumber ||
        !mobileIsTrue ||
        !this.personalDataAccept ||
        !this.acceptTermCheckBox
      ) {
        return false
      } else return true
    },
    generalFormValidation() {
      const tcPattern = /^([0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9])$/
      const mobilePattern = /(05|5)[0-9][0-9][0-9]([0-9]){6}/
      const name = this.item.customer.name
      const surname = this.item.customer.surname
      const tc = this.item.customer.identityNumber
      const mobileNumber = this.item.customer.mobileNumber
      const tcIsTrue = tcPattern.test(tc)
      const mobileIsTrue = mobilePattern.test(mobileNumber)

      if (
        !name ||
        !surname ||
        !tc ||
        !mobileNumber ||
        !tcIsTrue ||
        !mobileIsTrue ||
        !this.personalDataAccept ||
        !this.acceptTermCheckBox
      ) {
        return false
      } else return true
    }
  },
  computed: {
    headerImage() {
      const arr = this.$route.path.split("/")
      const route = arr[1]
      const path = require(`@/assets/category-banners/${route}.png`)
      return path
    },
    formValidation() {
      const mobilePattern = /(05|5)[0-9][0-9][0-9]([0-9]){6}/
      const name = this.item.customer.name
      const surname = this.item.customer.surname
      const mobileNumber = this.item.customer.mobileNumber
      const mobileIsTrue = mobilePattern.test(mobileNumber)
      if (this.$route.name === "ForeignHealthInsurance") {
        if (
          !name ||
          !surname ||
          !mobileNumber ||
          !mobileIsTrue ||
          !this.acceptTermCheckBox ||
          !this.personalDataAccept
        ) {
          return false
        } else return true
      } else {
        const tcPattern = /^([0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9])$/
        const tc = this.item.customer.identityNumber
        const tcIsTrue = tcPattern.test(tc)
        if (
          !name ||
          !surname ||
          !tc ||
          !mobileNumber ||
          !tcIsTrue ||
          !mobileIsTrue ||
          !this.acceptTermCheckBox ||
          !this.personalDataAccept
        ) {
          return false
        } else return true
      }
    }
  },
  watch: {
    successDialog() {
      if (!this.successDialog) {
        this.$router.push({ name: this.$route.name })
      }
    }
  }
}
</script>
